import { getRouterLocaleInfo, defaultCountry } from './getRouterLocaleInfo'
import { getDefaultLocale } from './getDefaultLocale'

export const mapRouterLocaleToCountryCode = (locale?: string): string => {
    if (!locale) {
        locale = getDefaultLocale()
    }
    const routerLocaleInfo = getRouterLocaleInfo()
    if (!routerLocaleInfo) {
        return defaultCountry
    }
    return routerLocaleInfo[locale]?.countryCode ?? defaultCountry
}
